// 팝업 설정
export const POPUP_WIDTH = 500
export const POPUP_HEIGHT = 700
export const POPUP_NAME = 'nicepass_popup'

export const VERIFICATION_MESSAGE_TYPE = {
  COMPLETE: 'NICE_VERIFICATION_COMPLETE',
  ERROR: 'NICE_VERIFICATION_ERROR',
} as const

export type VerificationMessageType = typeof VERIFICATION_MESSAGE_TYPE.COMPLETE | typeof VERIFICATION_MESSAGE_TYPE.ERROR

export interface VerificationMessage {
  type: VerificationMessageType
  errorMsg?: string
}

// NICE API URL
export const NICE_FORM_ACTION = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb'
